import { createPortal } from 'react-dom';
import styles from '../../../../styles/automation/index.module.scss';
import SmartInputToolbar from './SmartInputToolbar';

export default function SmartInputDropdown({
    show,
    activeLength,
    dropdownPortalRef,
    dropdownPosition,
    dropdownMode,
    suggestions,
    fileSuggestions,
    activeIndex,
    descriptions,
    fileDescriptions,
    dropdownListRef,
    insertToken,
    setSelectedIndex,
}) {
    if (!show || activeLength <= 0) return null;

    const dropdownContent = (
        <div
            ref={dropdownPortalRef}
            className={styles.variableDropdownPortal}
            style={{
                position: 'fixed',
                top: dropdownPosition.top,
                left: dropdownPosition.left,
                zIndex: 9999,
            }}
            onMouseDown={(e) => e.stopPropagation()}
        >
            <SmartInputToolbar
                dropdownMode={dropdownMode}
                suggestions={suggestions}
                fileSuggestions={fileSuggestions}
                activeIndex={activeIndex}
                descriptions={descriptions}
                fileDescriptions={fileDescriptions}
                dropdownListRef={dropdownListRef}
                insertToken={insertToken}
                setSelectedIndex={setSelectedIndex}
            />
        </div>
    );

    return createPortal(dropdownContent, document.body);
}
